module.exports = __webpack_public_path__ + "../static/img/base_firewall.b4ef15e8.png";